import ReviewAppointmentPage from "./ReviewAppointmentPage";

export default ReviewAppointmentPage;
